import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["displayName", "roleText", "avatarSrc", "avatarSize"];
import { CUIAvatar } from 'connect-dot-com-ui-components/Components/CUIAvatar/CUIAvatar';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { HomepageCardBackgroundGradient } from 'connect-dot-com-ui-components/Components/CUIHomepageCard/utils/backgroundGradients';
import { CUIVStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HomepageHighlightedMember(_ref) {
  let {
      displayName,
      roleText,
      avatarSrc,
      avatarSize = 'full'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CUIVStack, Object.assign({
    alignContent: "center"
  }, rest, {
    children: [/*#__PURE__*/_jsx(CUIBox, {
      background: `linear-gradient(${HomepageCardBackgroundGradient.kyotoCarnaby})`,
      padding: "0.2rem",
      borderRadius: "full",
      children: /*#__PURE__*/_jsx(CUIAvatar, {
        src: avatarSrc,
        width: avatarSize,
        height: avatarSize,
        name: displayName
      })
    }), /*#__PURE__*/_jsxs(CUIVStack, {
      spacing: 1,
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(CUIText, {
        fontWeight: "bold",
        children: displayName
      }), /*#__PURE__*/_jsx(CUIText, {
        variant: "micro",
        children: roleText
      })]
    })]
  }));
}